module.exports = __webpack_public_path__ + "img/user01.68294787.png";